<template>
  <v-container
    id="download"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style=" height: calc(100% - 130px)"
  >
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>

    <base-material-card
      icon="mdi-cloud-download"
      class="px-5 pt-3"
      min-height="100%"
    >
      <template v-slot:after-heading>
        <span class="card-title font-weight-light mr-4">
          {{ (items[0]?.sezione || section).toUpperCase().replace('_', ' ') }}
        </span>
      </template>
      <v-row
        class="fill-height"
        justify="space-around"
      >
        <v-col
          cols="12"
          md="6"
        >
          <v-list>
            <template v-for="(item, index) in items">
              <template v-if="index==0 || items[index-1].header!=item.header">
                <v-subheader
                  :key="`hdr_${index}`"
                  class="text-h3 font-weight-light"
                  v-text="item.header"
                />

                <v-divider
                  :key="`hdrdiv_${index}`"
                />
              </template>
              <v-list-item
                :key="`file_${index}`"

                @click="download(item.filename)"
              >
                <v-list-item-icon v-if="item.icona.startsWith('mdi-')">
                  <!-- <v-img :src="item.avatar" /> -->
                  <v-icon
                    large
                    color="red"
                    class="mr-8"
                  >
                    {{ item.icona }}
                  </v-icon>
                </v-list-item-icon>
                <v-avatar
                  v-else
                  size="80"
                >
                  <v-img
                    contain
                    :src="item.icona"
                  />
                </v-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.title }}<br>
                    <span class="text-caption">
                      {{ item.subtitle }}
                    </span>
                  </v-list-item-title>
                  <v-divider :key="`div_${index}`" />
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-col>
      </v-row>
    </base-material-card>
    <v-dialog
      v-model="progress"
      max-width="500"
    >
      <v-card>
        <v-card-text>
          <v-progress-circular
            indeterminate
            color="primary"
            size="32"
            class="ma-6"
          /> Download file in corso... {{ Math.floor(progress) }}%
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import engine from '../../plugins/engine'
  import Config from '@/config.js'

  export default {
    name: 'Blog',
    components: { },
    props: {
      section: {
        type: String,
        default: '',
      },

    },
    data () {
      return {
        loading: false,
        show: true,
        tabdata: [],
        progress: null,
      }
    },
    computed: {
      ...mapState(['auth']),
      items () {
        return this.tabdata.filter(itm => itm.voce_menu.toLowerCase() === this.section.toLowerCase())
        // return this.tabdata
      },

    },
    watch: {

    },
    mounted () {
      this.listaDownloads()
    },
    beforeDestroy () {

    },
    methods: {
      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      listaDownloads: function () {
        engine.listaDownloads()
          .then((result) => {
            console.log('listaDownloads', result)
            this.tabdata = result.data
          })
      },
      async  download (filename) {
        this.progress = 0
        var headers = new Headers({
          Authorization: Config.apikey,
          'Content-Type': 'application/json',
        })

        const requestOptions = {
          method: 'POST',
          redirect: 'follow',
          headers: headers,
          body: JSON.stringify({ filename: filename }),
        }

        const response = await fetch(Config.apiurl + '/download', requestOptions)

        const total = Number(response.headers.get('X-File-Size'))
        console.log('total', total)
        const reader = response.body.getReader()

        let received = 0
        const chunks = []
        console.log('startdownload')
        while (true) {
          const { done, value } = await reader.read()
          if (done) break

          chunks.push(value)
          received += value.length
          this.progress = (received / total) * 100
        }

        // Ricostruisce il file
        const blob = new Blob(chunks)

        // Recupera il nome file dagli header se presente
        let filenameFromHeader = 'download.bin'
        const cd = response.headers.get('Content-Disposition')
        if (cd && cd.includes('filename=')) {
          filenameFromHeader = cd.split('filename=')[1].replace(/"/g, '')
        }

        // (C2) TO "FORCE DOWNLOAD"
        var url = window.URL.createObjectURL(blob)
        var anchor = document.createElement('a')
        anchor.href = url
        // anchor.download = obj.filename || `${this.$store.state.userinfo.email}-vpn.cfg`
        anchor.download = filenameFromHeader
        anchor.click()
        // // (C3) CLEAN UP
        window.URL.revokeObjectURL(url)
        this.progress = null
        // document.removeChild(anchor)
      },
      // download (filename) {
      //   engine.download(filename)
      //     .then((obj) => {
      //       if (obj.blob) {
      //         console.log('=====>obj download:', obj)
      //         // (C2) TO "FORCE DOWNLOAD"
      //         var url = window.URL.createObjectURL(obj.blob)
      //         var anchor = document.createElement('a')
      //         anchor.href = url
      //         // anchor.download = obj.filename || `${this.$store.state.userinfo.email}-vpn.cfg`
      //         anchor.download = obj.filename
      //         anchor.click()
      //         // // (C3) CLEAN UP
      //         // window.URL.revokeObjectURL(url)
      //         // document.removeChild(anchor)
      //       }
      //     }).catch(errore => {
      //       console.log(errore)
      //     })
      // },

    },

  }
</script>
